import { ButtonHTMLAttributes, ReactNode } from 'react'

import { cn } from '@/shared/lib'

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode
  className?: string
}

export const Chip = ({ children, className, ...props }: Props) => {
  return (
    <button
      type="button"
      className={cn(
        'typo-body2 h-9 w-16 shrink-0 cursor-pointer truncate rounded-full font-medium',
        'bg-gray-0 px-2.5 py-1.5 text-purple-500',
        'hover:bg-purple-50',
        'transition-colors',
        className,
      )}
      data-item-type="recommend-keyword"
      {...props}
    >
      {children}
    </button>
  )
}
